import { render, staticRenderFns } from "./DashCard.vue?vue&type=template&id=6326239c&"
import script from "./DashCard.vue?vue&type=script&lang=js&"
export * from "./DashCard.vue?vue&type=script&lang=js&"
import style0 from "./DashCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports